<template>
    <div
        class="bg-white" :class="{
            'border-danger' : !valid,
            'p-0': mini,
            'p-3 border shadow-sm rounded': !mini,
        }"
        @click="$emit('reset-validation', true)"
    >  
        <b-icon v-if="!valid" icon="exclamation-circle" class="text-danger float-right"/>
        <div> 
            <b-card no-body> 
                <b-tabs pills card fill>
                    <b-tab
                        v-for="programme_id in eventProgrammes" :key="programme_id"
                        :title="$config.getProgrammeNameById(programme_id)"
                        @click="activeProgramme = programme_id"
                        :active="programme_id === activeProgramme"
                    >
                        <b-card-text>
                            <div v-for="year in Object.keys(groupsByProgrammeAndYear[programme_id] || {})" :key="`${programme_id}.${year}`" class="d-flex flex-column" :class="mini ? 'mb-2' : 'mb-3'">
                                <div class="d-flex flex-row align-items-center">
                                    <input
                                        :id="`year-${year}`"
                                        type="checkbox"
                                        class="form-check mr-2"
                                        :checked="yearSelected(year)"
                                        @click="disabled ? undefined : toggleYearSelected(year)"
                                        :disabled="disabled"
                                    />
                                    <label :for="`year-${year}`" class="form-check-label" :class="{ 'text-sm': mini }">{{ `${$t('year')} ${year}` }}</label>
                                </div>

                                <div class="d-flex flex-row flex-wrap" v-if="innerValue !== undefined">
                                    <div
                                        v-for="group in groupsByProgrammeAndYear[programme_id][year]"
                                        :key="`${programme_id}.${year}.${group.group_id}`"
                                        class="btn"
                                        :class="`${isSelected(group) ? 'btn-primary' : 'btn-outline-dark'} ${mini ? 'btn-sm mr-1 mt-1' : 'mr-2 mt-2'}`"
                                        @click="disabled ? undefined : toggleGroupSelected(group)"
                                    >
                                        {{ group.title ? group.title : $config.getGroupNameById(group.group_id) }}
                                    </div>
                                </div>
                            </div>
                        </b-card-text>
                    </b-tab>
                    <b-tab v-if="availableProgrammes.length > 0 && !monoProgramme || eventProgrammes.length === 0">
                        <template #title>
                            <strong>{{$t('add-programme')}}<b-icon icon="plus"></b-icon></strong>
                        </template>
                        <b-card-text style="min-width: 100%; width: 100%">
                            <div class="d-flex flex-row align-items-center" :class="mini ? 'mb-2' : 'mb-3'">
                                <div class="col-12">   
                                    <SelectInput 
                                        :options="availableProgrammes" 
                                        optionLabel="Name" 
                                        v-model="newProgramme" 
                                        :label="$t('programme')" 
                                        class="font-bold"
                                    />
                                    <button 
                                        class="btn btn-primary float-right"
                                        @click="addProgramme"
                                    >
                                        {{ $t('add') }}<b-icon icon="plus"></b-icon>
                                    </button>
                                </div>
                            </div>
                        </b-card-text>
                    </b-tab>
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        groups: Array,
        value: Array,
        valid: {
            type: Boolean,
            default: true,
        },
        disabled: Boolean,
        sortedGroups: Object,   // If passed, groups prop is ignored, must be sorted by programme and year
        mini: Boolean,
        monoProgramme: {// In case we want to limit this to a single programme
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            activeProgramme: undefined,
            newProgramme: undefined,
            groupsByProgrammeAndYear: {},
            innerValue: [...this.value],
            eventProgrammes: [...new Set(this.value.map(programme => programme.programme_id))],
        }
    },
    beforeMount() {
        // Let's structure our groups by year and programme in a dictionary
        if (this.sortedGroups) {
            this.groupsByProgrammeAndYear = this.sortedGroups
            this.determineActiveProgramme();

            return
        }
        this.sortGroups(this.groups)
    },
    methods: {
        sortGroups(groups) {
            this.groupsByProgrammeAndYear = {}
  
            for (const group of groups) {
                if (this.groupsByProgrammeAndYear[group.programme_id] === undefined) {
                    this.groupsByProgrammeAndYear[group.programme_id] = {}
                    this.groupsByProgrammeAndYear[group.programme_id][group.year] = [group]
                    continue
                }
                if (this.groupsByProgrammeAndYear[group.programme_id][group.year] === undefined) {
                    this.groupsByProgrammeAndYear[group.programme_id][group.year] = [group]
                    continue
                }
                this.groupsByProgrammeAndYear[group.programme_id][group.year].push(group)
            }
            //this.activeProgramme = Object.keys(this.groupsByProgrammeAndYear)[0]
            
            // const selectedProgrammes = [...new Set(this.innerValue.map(g => g.programme_id))];
            // if (selectedProgrammes.length > 0) {
            // this.activeProgramme = selectedProgrammes[0];
            // } else {
            // const programmeKeys = Object.keys(this.groupsByProgrammeAndYear);
            // this.activeProgramme = programmeKeys.length > 0 ? programmeKeys[0] : undefined;
            // }
            this.determineActiveProgramme();
        },
        determineActiveProgramme() {
            // Priority 1: Use programme from selected groups
            const selectedProgrammes = [...new Set(this.innerValue.map(g => g.programme_id))];
            if (selectedProgrammes.length > 0) {
                this.activeProgramme = selectedProgrammes[0];
                return;
            }
            
            // Priority 2: Use first available programme from groups
            const programmeKeys = Object.keys(this.groupsByProgrammeAndYear);
            this.activeProgramme = programmeKeys.length > 0 ? programmeKeys[0] : undefined;
        },
        toggleYearSelected(year) {
            const someSelected = this.innerValue.some(group => 
                group.year == year &&
                group.programme_id == this.activeProgramme
            )

            if (someSelected) {
                this.innerValue = this.innerValue.filter(group => 
                !(group.year == year && group.programme_id == this.activeProgramme)
                )
            } else {
                this.innerValue.push(...this.groupsByProgrammeAndYear[this.activeProgramme][year])
            }

            this.$emit('input', [...this.innerValue])
        },
        toggleGroupSelected(group) {
            const index = this.innerValue.findIndex(el => this.checkGroupEquality(el, group))

            if (index > -1) this.innerValue.splice(index, 1)
            else this.innerValue.push(group)

            this.$emit('input', [...this.innerValue])
        },
        isSelected(group) {
             return this.innerValue.findIndex(el => this.checkGroupEquality(el, group)) > -1
        },
        yearSelected(year) {
            return this.innerValue.some(group => group.year == year && 
            group.programme_id == this.activeProgramme)
        },
        checkGroupEquality(group0, group1) {
            return group0.programme_id == group1.programme_id
                && group0.year == group1.year
                && group0.group_id == group1.group_id
        },
        addProgramme(){
            if(!this.newProgramme) return;
            this.eventProgrammes = [...this.eventProgrammes, this.newProgramme.Id] 
            this.activeProgramme = this.newProgramme.Id
        }
    },
    watch: {
        value(newVal) {
            this.innerValue = [...newVal]
            this.eventProgrammes = [...new Set(newVal.map(programme => programme.programme_id))]
            this.determineActiveProgramme();
        },
        groups(newGroups) {
            this.sortGroups(newGroups)
        },
        // activeProgramme: {
        //     deep: true, 
        //     immediate: true,
        //     handler(newProgramme) {
        //         this.$emit('active-programme',newProgramme)
        //     },
        // }
        activeProgramme(newProgramme) {
        // Only emit valid values (prevents undefined emits)
        if (newProgramme != null) { // Works for 0, "0", etc.
            this.$emit('active-programme', newProgramme);
        }
        }
    },
    computed: {
        availableProgrammes(){
            const programmes = Object.values(this.$config.getValue('programmes'));
            const subsetIds = new Set(this.eventProgrammes);
            return programmes.filter(p => !subsetIds.has(p.Id));            
        }
    }
}
</script>
